import { useQuery } from "@tanstack/react-query";
import { getMyUsageTrends } from "../../../helpers/apis";
import { TopAITeammatesCard } from "../components/TopAITeammatesCard";
import { CreditsUsageHistory } from "../components/CreditsUsageHistory";
import {
  Card,
  CardContent,
  CardHeader,
  Separator,
  Typography,
} from "@altimateai/lego";
import { Spinner, Stack } from "@altimateai/lego";
import { UsageTrendChart } from "../components/UsageTrendChart";
import { useDateFromSearchParams } from "@/helpers/useTimeHooks";
import dayjs from "dayjs";
import { DateRange } from "@/components/dateRange";
import { CREDITS_DATE_PREFIX } from "../constants";

export const MyUsageTab = () => {
  const { startDate, endDate, onUpdate } = useDateFromSearchParams(
    dayjs().subtract(30, "day").toDate(),
    dayjs().toDate(),
    CREDITS_DATE_PREFIX
  );

  const { data: graphData, isLoading: isTrendsDataLoading } = useQuery({
    queryKey: ["my-usage-trends", startDate, endDate],
    queryFn: () =>
      getMyUsageTrends({
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString(),
      }),
  });

  return (
    <div className="al-space-y-6">
      {/* Usage Analytics Section */}
      <Card>
        <CardHeader>
          <Stack align={"center"} justify={"between"}>
            <Typography variant={"section-heading"}>Usage Analytics</Typography>
            <DateRange
              startDate={startDate}
              endDate={endDate}
              onDateRangeSelect={(start, end) => {
                onUpdate(start, end);
              }}
            />
          </Stack>
        </CardHeader>
        <Separator />
        <CardContent>
          {isTrendsDataLoading ? (
            <Stack justify={"center"} align={"center"} className={"al-min-h-80"} gap={"lg"}>
              <Spinner size={"lg"} />
              <span>Loading...</span>
            </Stack>
          ) : (
            <Stack gap={"lg"} className={"al-w-full al-mt-4 al-max-h-80"}>
              <Stack
                gap={"lg"}
                direction={"column"}
                className={"al-p-3 al-border al-rounded-md al-w-full"}
              >
                <Typography variant={"caption"}>Credit Usage Trend</Typography>
                <UsageTrendChart
                  data={graphData?.graph_data ?? []}
                  startDate={startDate}
                  endDate={endDate}
                />
              </Stack>
              <Stack
                gap={"lg"}
                direction={"column"}
                className={"al-p-3 al-border al-rounded-md al-w-full"}
              >
                <Typography variant={"caption"}>My Top AI Teammates</Typography>
                <TopAITeammatesCard
                  teammates={graphData?.top_ai_teammates.teammates ?? []}
                  totalCredits={graphData?.top_ai_teammates.total_credits_consumed ?? 0}
                />
              </Stack>
            </Stack>
          )}
        </CardContent>
      </Card>
      <CreditsUsageHistory />
    </div>
  );
};
